import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GoalsPlanning } from 'src/app/core/models/goals-planning';
import { BasePlanningService } from 'src/app/core/services/base-planning.service';
import { Mongo } from '../../core/models/mongo';

@Injectable({ providedIn: 'root' })
export class PlanningService extends BasePlanningService {
  createPlan(tenant: string, plan: GoalsPlanning): Observable<HttpResponse<any>> {
    return this.http.post(`${this.BASE_URL}/${tenant}/${this.planningCollection}`, plan, { observe: 'response' });
  }

  deletePlan(tenant: string, id: Mongo.ObjectId) {
    return this.http.delete(`${this.BASE_URL}/${tenant}/${this.planningCollection}/${id.$oid}`, { observe: 'response' });
  }
}
